import MarkupEmbeddedVideo from '@app/components/MarkupEmbeddedVideo'
import MarkupText from '@app/components/MarkupText'
import { FeedItemType, LeadPriority } from '@app/models/enums'
import { IFeedItem } from '@app/models/FeedItem'
import * as React from 'react'
import FeedItemAttachments from './FeedItemAttachments'

interface IFeedItemBodyProps {
  item: IFeedItem
  setSelectedPhoto: (feedItemId: string, selectedPhotoId: string) => any
}

export default class FeedItemBody extends React.PureComponent<
  IFeedItemBodyProps
> {
  public render() {
    let iconClasses: string | undefined

    switch (this.props.item.leadPriority) {
      case LeadPriority.High:
        iconClasses = 'text-danger'
        break

      case LeadPriority.Low:
        iconClasses = 'text-info'
        break

      default:
        break
    }

    const priority = (
      <div
        className={`ml-1 ${iconClasses} align-self-center`}
        style={{ fontSize: '0.775rem' }}
      >
        {' '}
        ({this.props.item.leadPriority})
      </div>
    )

    return (
      <div className='feed-item-body p-2'>
        {this.props.item.type === FeedItemType.Lead && (
          <div className='d-flex flex-row font-weight-bold mb-1'>
            {`${this.props.item.title} `} {priority}
          </div>
        )}
        <MarkupText text={this.props.item.markup} />
        <FeedItemAttachments
          attachments={this.props.item.attachments}
          className='my-2'
          feedItemId={this.props.item.id}
          selectedPhotoId={this.props.item.selectedPhoto}
          setSelectedPhoto={this.props.setSelectedPhoto}
        />
        <MarkupEmbeddedVideo className='my-2' text={this.props.item.markup} />
      </div>
    )
  }
}
